<template>
  <div class="navigation-tabs">
    <ul class="navigation-tabs__menu">
      <li v-for="(link, index) in props.links" :key="index">
        <NuxtLink
          class="navigation-tabs__link text-uppercase text"
          :class="{
            '--active': route.name.includes(link?.route?.name),
          }"
          :to="localePath(link?.route)"
        >
          {{ link?.title }}
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'WidgetNavigationTabs',
}
</script>

<script setup>
const props = defineProps({
  links: Array,
})

const route = useRoute()
</script>

<style lang="scss">
@import './style.scss';
</style>
